import { LinkProps, Link } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const SettingsLink: FC<PropsWithChildren<LinkProps>> = (props) => (
  <Link display="block" mb="4" {...props} />
);
